import firebase from 'firebase'
import 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'


// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDwO3AbwegWME5hXJnt4g3Xc2M2PskX370",
    authDomain: "petcost--app.firebaseapp.com",
    projectId: "petcost--app",
    storageBucket: "petcost--app.appspot.com",
    messagingSenderId: "1064233557803",
    appId: "1:1064233557803:web:8876224a208d3675476f6e"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

// var auth = firebase.auth()

export default firebase